import React, { useState } from "react"
import IntlProps from "../../state/helpers/IntlProps"
import { injectIntl } from "react-intl"
import { Modal } from "react-bootstrap"
import { AddProductSupplierModalProps } from "../../common/types/product"
import { ADD_PRODUCT_SUPPLIER_MODAL_MESSAGES } from "../../utils/product"
import { CancelButton, SaveButton } from "../../common/button"
import CustomerSelect from "../../customer/selection.component"
import { useDispatch, useSelector } from "react-redux"
import { ProductAction } from "../../state/product/actions"
import { ProductSelector } from "../../state/product/selectors"
import validator from "validator"

export const AddProductSupplierModal = injectIntl((props: AddProductSupplierModalProps & IntlProps) => {
    const [selectedValue, setSelectedValue] = useState("")
    const supplierCosts = useSelector(ProductSelector.getSupplierCosts)
    const dispatch = useDispatch()
    const onSave = () => {
        const isID = validator.isUUID(selectedValue)
        if (!isID) {
            dispatch(ProductAction.patch({
                supplierCost: {
                    supplierName: selectedValue,
                }
            }))

        } else {
            dispatch(ProductAction.patch({
                supplierCost: {
                    supplierId: selectedValue,
                }
            }))
        }

        props.onCloseCallback()
    }

    const onChange = (value: string) => {
        setSelectedValue(value)
    }

    const disabled = !selectedValue
    const currentSupplierIds = supplierCosts.map(supplierCost => supplierCost.attributes.supplierId)
    return (
        <Modal
            show
            className={"custom-modal"}
            onHide={props.onCloseCallback}
            backdrop="static"
            centered={true}
        >
            <Modal.Header closeButton>
                {props.intl.formatMessage(ADD_PRODUCT_SUPPLIER_MODAL_MESSAGES.header)}
            </Modal.Header>

            <Modal.Body>
                <label>{props.intl.formatMessage(ADD_PRODUCT_SUPPLIER_MODAL_MESSAGES.label_supplier_name)}</label>
                <CustomerSelect
                    value={selectedValue}
                    contactType="suppliers"
                    allowCreate={true}
                    onChange={onChange}
                    filters={{
                        "_id{notOneOf};": currentSupplierIds
                    }}
                />
            </Modal.Body>

            <Modal.Footer>
                <CancelButton onClickCallback={props.onCloseCallback}/>
                <SaveButton disabled={disabled} onClickCallback={onSave}/>
            </Modal.Footer>
        </Modal>

    )

})


// WEBPACK FOOTER //
// ./src/product/modal/AddProductSupplierModal.tsx